import React from 'react'
import styled from 'styled-components'
import { SvgAttr } from '../SvgAttr/SvgAttr'

export const IconSmsText = ({
  classes = '',
  styles,
  width = '40px',
  height = '40px',
  color = 'currentColor',
}) => {
  return (
    <Svg
      viewBox='0 0 72 72'
      className={classes}
      styles={styles}
      width={width}
      height={height}
      xmlns='http://www.w3.org/2000/svg'
      version='1.1'
    >
      <title>SMS</title>
      <Path
        color={color}
        d='M55.67,9.48c2.78,0,5.32,1.55,7.31,3.66,1.87,1.99,2.76,4.31,3.27,6.96v19.96c0,3.51-2.89,7.15-5.88,8.89-4.76,2.77-11.54.9-16.86,1.53-3.64,4.15-7.92,7.72-13.03,9.92-1.07.46-5.79,2.26-6.61,2.12s-1.61-1.15-1.35-1.99c.24-.76,1.83-1.93,2.41-2.66,1.74-2.16,2.91-4.76,3.53-7.45h-12.72c-4.06,0-8.56-4.9-9.52-8.64s-.75-16.42-.44-20.81c.4-5.74,4.47-10.78,10.34-11.49h39.54ZM41.39,47.72c1.23-.99,12.8.33,16.12-.89,2.36-.87,4.46-3,5.15-5.45.82-2.93.65-17.31.33-20.91-.36-4.2-3.81-7.35-7.93-7.71-12.29-1.06-26.21.01-38.54.01-3.16.31-6.27,2.93-7.11,6.01-.79,2.9-.67,17.4-.32,20.9,1.08,10.94,14.87,6.79,21.8,7.7.55.07,1.16.38,1.32.95.47,1.6-2.13,7.24-2.97,8.91,4.14-1.34,7.77-4.45,10.71-7.58.43-.46,1.08-1.65,1.45-1.95Z'
      />
      <Path
        color={color}
        d='M32.46,22.92c.57.36,2.72,7.61,3.81,8.55l3.57-8.55,2.21-.03,2.28,13.88-2.8-.14-1.36-8.2c-.68,1.12-3.01,7.83-3.65,8.22-.35.22-.88.23-1.14-.13l-3.27-7.84-1.38,8.09h-3.02s2.52-13.9,2.52-13.9l2.22.04Z'
      />
      <Path
        color={color}
        d='M19.97,27.36c1.28,1.34,4.99.8,5.67,4.04,1.25,5.92-6.58,7.61-9.49,3.19l1.62-1.86c.77,2.03,5,2.62,5.16.1.17-2.65-5.5-1.96-6.02-5.3-.81-5.15,5.05-6.56,8.29-3.5l-1.38,1.83c-1.37-2.04-5.75-.49-3.84,1.5Z'
      />
      <Path
        color={color}
        d='M50.2,27.36c1.28,1.34,4.99.8,5.67,4.04,1.25,5.92-6.58,7.61-9.49,3.19l1.62-1.86c.77,2.03,5,2.62,5.16.1.17-2.65-5.5-1.96-6.02-5.3-.81-5.15,5.05-6.56,8.29-3.5l-1.38,1.83c-1.37-2.04-5.75-.49-3.84,1.5Z'
      />
    </Svg>
  )
}

const Svg = styled(SvgAttr)`
  width: ${(props) => props.width};
  height: ${(props) => props.height};
  ${(props) => props.styles}
`

const Path = styled.path`
  transition: all 0.2s ease-in-out;
  fill: ${(props) => props.color};
`